<template>
  <b-container fluid>
    <h1 v-translate="{ countdown }">FLEXES Control <small>(Autorefresh in %{countdown}s)</small></h1>
    <b-card no-body>
      <b-tabs card v-model="tabIndex">
        <b-tab :title="$gettext('PICKEDUP FLEX without ML app scan')">
          <b-row>
            <b-col cols="3">
              <p>
                <b-form-checkbox id="pikedup-flex-grouped" v-model="pickedupFlexGroupedByCourier" :value="true"
                  :unchecked-value="false">
                  <translate>Group by courier</translate>
                </b-form-checkbox>
                <b-form-checkbox id="pikedup-flex-grouped-company" v-model="pickedupFlexGroupedByCompany" :value="true"
                  :unchecked-value="false">
                  <translate>Group by Company</translate>
                </b-form-checkbox>
              </p>
            </b-col>
            <b-col v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0" cols="3">
              <b-form-group>
                <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
                <b-form-select v-model="filterWarehouse" :options="warehousesSelect">
                  <template slot="first">
                    <option :value="null" v-translate>None</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table striped hover :items="platformPickedups"
                :fields="['id', {key: 'courier', label: $gettext('Courier')}, {key: 'company_id', label: $gettext('Company')}, {key: 'addressTo', label: $gettext('Destination')}, {key: 'pickedupAt', label: $gettext('Picked Up At')}, {key: 'delayedBy', label: $gettext('Delayed By')}]"
                :current-page="0"
                :per-page="1000" v-if="!pickedupFlexGroupedByCourier && !pickedupFlexGroupedByCompany" show-empty
                :empty-text="$gettext('There are no rows to show')">
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong v-translate>Loading...</strong>
                </div>
                <template v-slot:cell(id)="row">
                  <a :href="'/edit/shippings/' + row.value" target="_blank">{{ row.value | uuid }}</a> <a href="#"
                    @click.prevent="copyToClipboard(row.value)" class="text-secondary"
                    :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
                </template>
                <template v-slot:cell(courier)="row">
                  <div v-if="row.item.courier">
                    <user-card :user='row.item.courier' :profile-picture="false" :with-titles="false"
                      :vehicle-types-prop="vehicleTypes" />
                  </div>
                </template>
                <template v-slot:cell(company_id)="row">
                  <div v-if="row.item.company_id">
                    <b-badge variant="dark" v-translate>Company</b-badge><br>
                    <a :href="'/edit/companies/' + row.item.company_id" target="_blank">#{{ row.item.company_id }}</a>
                    {{ row.item.company.name }}
                  </div>
                  <div v-else>
                    <b-badge variant="secondary" v-translate>Particular</b-badge><br>
                    <a :href="'/edit/users/' + row.item.user_id" target="_blank">#{{ row.item.user_id }}</a>
                    {{ row.item.user.name }}
                  </div>
                </template>
                <template v-slot:cell(addressTo)="row">
                  {{ row.item.address_to.formatted_address }}
                  <div v-translate="{data: row.item.status}">
                    Current Status: %{data}
                  </div>
                </template>
                <template v-slot:cell(pickedupAt)="row">
                  {{ moment.utc(row.item.status_history.find(x => x.status === 'INTRANSIT').created_at).tz($tz).format('L LT')}}
                </template>
                <template v-slot:cell(delayedBy)="row">
                  {{ elapsedTime(row.item.status_history.find(x => x.status === 'INTRANSIT').created_at) }}
                  <b-button size="sm" variant="primary" @click.prevent="forcePlatformCheck(row.item.id)" v-translate>
                    Check ML Status
                  </b-button>
                </template>
              </b-table>
              <b-row v-else-if="pickedupFlexGroupedByCourier">
                <b-col md="3" v-for="(courier, index) in groupedPlatformPickedupsByCourier" :key="index">
                  <b-card>
                    <b-card-title class="mb-0">
                      <a :href="'/edit/users/' + courier.id" target="_blank">#{{ courier.id }}</a>
                      {{ courier.name }}
                      <b-badge :variant="courier.failed < 5 ? 'dark' : 'danger'"
                        @click="selectedSubject = courier; theSubject = 'courier'; showingShippings = 'pickedup'; shippings = courier.shippings"
                        v-b-modal.modalFailedShippings>{{ courier.failed }}</b-badge></b-card-title>
                    <b-card-text>
                      <div v-if="courier.company" class="mb-2">
                        <span class="badge"
                          :style="'background-color: ' + stringToColour(' ' + courier.company.id + courier.company.id + courier.company.id + courier.company.id) + ';' + textContrastColor(stringToColour(' ' + courier.company.id + courier.company.id + courier.company.id + courier.company.id))">{{ courier.company.name }}</span>
                      </div>
                      <span v-if="courier.phone">
                        <a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;"
                          :href="$options.filters.whatsappize(courier.phone)">WhatsApp</a>
                        {{ courier.phone }}
                      </span>
                      <b-badge variant="danger" v-else v-translate>NO PHONE!</b-badge>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
              <b-row v-else-if="pickedupFlexGroupedByCompany">
                <b-col md="3" v-for="(company, index) in groupedPlatformPickedupsByCompany" :key="index">
                  <b-card>
                    <b-card-title class="mb-0">
                      <a :href="'/edit/companies/' + company.id" target="_blank">#{{ company.id }}</a>
                      {{ company.name }}
                      <b-badge :variant="company.failed < 5 ? 'dark' : 'danger'"
                        @click="selectedSubject = company; theSubject = 'company'; showingShippings = 'pickedup'; shippings = company.shippings"
                        v-b-modal.modalFailedShippings>{{ company.failed }}</b-badge></b-card-title>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$gettext('FLEX with pending ML app scan')">
          <b-row>
            <b-col cols="3">
              <p>
                <b-form-checkbox id="failed-flex-grouped" v-model="failedFlexGroupedByCourier" :value="true"
                  :unchecked-value="false">
                  <translate>Group by courier</translate>
                </b-form-checkbox>
                <b-form-checkbox id="failed-flex-grouped-company" v-model="failedFlexGroupedByCompany" :value="true"
                  :unchecked-value="false">
                  <translate>Group by Company</translate>
                </b-form-checkbox>
              </p>
            </b-col>
            <b-col v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0" cols="3">
              <b-form-group>
                <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
                <b-form-select v-model="filterWarehouse" :options="warehousesSelect">
                  <template slot="first">
                    <option :value="null" v-translate>None</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="text-right">
              <span v-if="isSuperAdmin || isAdmin || isOperatorSupervisor">
                <b-form-select v-model="hoursToCheck"
                  :options="[{ text: $gettext('All 7 days'), value: null }, { text: $gettext('Last 12 hours'), value: 12 }, { text: $gettext('Last 24 hours'), value: 24 }, { text: $gettext('Last 48 hours'), value: 48 }]"
                  class="w-auto" :disabled="bulkChecking"></b-form-select>
                <b-button size="sm" variant="primary" @click.prevent="bulkForcePlatformCheck" :disabled="bulkChecking">
                  <b-spinner small v-if="bulkChecking"></b-spinner>
                  <span v-show="!bulkChecking" v-translate>Bulk Force Check</span>
                  <span v-show="bulkChecking" v-translate="{check: checkCount, total: toCheck.length, fixed: checkFixed}">
                    Checking %{check}/%{total}. Updated: %{fixed}
                  </span>
                </b-button>
              </span>

              <span v-translate="{data: platformDeliveredsTotal + platformDeliveredsOkTotal}">FLEX total <small>(last 7 days)</small>: <strong>%{data}</strong>.</span>
              <span v-translate="{data: (platformDeliveredsTotal * 100 / (platformDeliveredsTotal + platformDeliveredsOkTotal)).toFixed(2) || 0}">Not scanned: <strong>%{data}%</strong>.</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table striped hover :items="platformDelivereds"
                :fields="['id', {key: 'courier', label: $gettext('Courier')}, {key: 'company_id', label: $gettext('Company')}, {key: 'addressTo', label: $gettext('Destination')}, {key: 'currentStatus', label: $gettext('Status')}, {key: 'delayedBy', label: $gettext('Delayed By')}, {key: 'qr', label: $gettext('QR')}]"
                :current-page="0" :per-page="1000" v-if="!failedFlexGroupedByCourier && !failedFlexGroupedByCompany"
                show-empty :empty-text="$gettext('There are no rows to show')">
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong v-translate>Loading...</strong>
                </div>
                <template v-slot:cell(id)="row">
                  <a :href="'/edit/shippings/' + row.value" target="_blank">{{ row.value | uuid }}</a> <a href="#"
                    @click.prevent="copyToClipboard(row.value)" class="text-secondary"
                    :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
                </template>
                <template v-slot:cell(courier)="row">
                  <div v-if="row.item.courier">
                    <user-card :user='row.item.courier' :profile-picture="false" :with-titles="false"
                      :vehicle-types-prop="vehicleTypes" />
                  </div>
                </template>
                <template v-slot:cell(company_id)="row">
                  <div v-if="row.item.company_id">
                    <b-badge variant="dark" v-translate>Company</b-badge><br>
                    <a :href="'/edit/companies/' + row.item.company_id" target="_blank">#{{ row.item.company_id }}</a>
                    {{ row.item.company.name }}
                  </div>
                  <div v-else>
                    <b-badge variant="secondary" v-translate>Particular</b-badge><br>
                    <a :href="'/edit/users/' + row.item.user_id" target="_blank">#{{ row.item.user_id }}</a>
                    {{ row.item.user.name }}
                  </div>
                </template>
                <template v-slot:cell(addressTo)="row">
                  {{ row.item.address_to.formatted_address }}
                </template>
                <template v-slot:cell(currentStatus)="row">
                  {{ row.item.status }}<br>
                  {{ moment.utc(row.item.status_history[0].created_at).tz($tz).format('L LT') }}
                </template>
                <template v-slot:cell(delayedBy)="row">
                  {{ elapsedTime(row.item.delayedSinceDate) }}
                  <b-button size="sm" variant="primary" @click.prevent="forcePlatformCheck(row.item.id)" v-translate>
                    Force Check
                  </b-button>
                </template>
                <template v-slot:cell(qr)="row">
                  <div class="text-center"
                    v-if="(row.item.external_label && row.item.external_label.code) || (row.item.external_label && row.item.external_label.id)">
                    <b-button size="sm" variant="link" @click.prevent="qrData = row.item.external_label"
                      v-b-modal.modalShowQr style="padding: .25rem">
                      <font-awesome-icon icon="qrcode" size="3x" />
                    </b-button>
                  </div>
                </template>
              </b-table>
              <b-row v-else-if="failedFlexGroupedByCourier">
                <b-col md="3" v-for="(courier, index) in groupedPlatformDeliveredsByCourier" :key="index">
                  <b-card>
                    <b-card-title class="mb-0">
                      <a :href="'/edit/users/' + courier.id" target="_blank">#{{ courier.id }}</a>
                      {{ courier.name }}
                      <b-badge :variant="courier.failed < 5 ? 'dark' : 'danger'"
                        @click="selectedSubject = courier; theSubject = 'courier'; showingShippings = 'delivered'; shippings = courier.shippings"
                        v-b-modal.modalFailedShippings>{{ courier.failed }}</b-badge></b-card-title>
                    <b-card-text>
                      <div v-if="courier.company" class="mb-2">
                        <span class="badge"
                          :style="'background-color: ' + stringToColour(' ' + courier.company.id + courier.company.id + courier.company.id + courier.company.id) + ';' + textContrastColor(stringToColour(' ' + courier.company.id + courier.company.id + courier.company.id + courier.company.id))">{{ courier.company.name }}</span>
                      </div>
                      <span v-if="courier.phone">
                        <a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;"
                          :href="$options.filters.whatsappize(courier.phone)">WhatsApp</a>
                        {{ courier.phone }}
                      </span>
                      <b-badge variant="danger" v-else v-translate>NO PHONE!</b-badge>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
              <b-row v-else-if="failedFlexGroupedByCompany">
                <b-col md="3" v-for="(company, index) in groupedPlatformDeliveredsByCompany" :key="index">
                  <b-card>
                    <b-card-title class="mb-0">
                      <a :href="'/edit/companies/' + company.id" target="_blank">#{{ company.id }}</a>
                      {{ company.name }}
                      <b-badge :variant="company.failed < 5 ? 'dark' : 'danger'"
                        @click="selectedSubject = company; theSubject = 'company'; showingShippings = 'delivered'; shippings = company.shippings"
                        v-b-modal.modalFailedShippings>{{ company.failed }}</b-badge></b-card-title>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal id="modalPlatformCheck" ref="modalPlatformCheck" hide-footer :title="$gettext('Platform Info Check')"
      @hide="platformCheck = {}">
      <h4 v-translate="{data: platformCheck.status}">Status: %{data}</h4>
      <ul>
        <li v-for="(item, index) in platformCheck.statusHistory" :key="index">
          {{ index }}: {{ item !== null ? moment(item).format('L LT') : 'null' }}
        </li>
      </ul>
      <b-button
        v-show="(platformCheck && platformCheck.statusHistory && (platformCheck.statusHistory.date_delivered || platformCheck.statusHistory.date_first_visit))"
        size="sm" variant="primary" @click.prevent="updateShippingPlatformInfo(platformCheck.shippingId)" v-translate>
        Update Shipping Data
      </b-button>
    </b-modal>

    <b-modal size="md" id="modalShowQr" ref="modalShowQr" hide-header hide-footer @hide="qrData = {}">
      <img v-if="qrData.code || qrData.id"
        :src="'https://api.qrserver.com/v1/create-qr-code/?size=420x420&ecc=L&data=' + encodeURIComponent(qrData.code ? JSON.stringify(JSON.parse(qrData.code)) : JSON.stringify(qrData))"
        alt="">
    </b-modal>

    <b-modal size="xl" ref="modalFailedShippings" id="modalFailedShippings" hide-footer
      @hide="shippings = []; selectedSubject = {}">
      <div slot="modal-title" v-translate>FLEXES Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <user-card v-if="selectedSubject && theSubject === 'courier'" :user="selectedSubject" />
      <company-card v-if="selectedSubject && theSubject === 'company'" :company="selectedSubject" />
      <b-table striped hover :items="shippings"
        :fields="showingShippings === 'pickedup' ?
          ['id', {key: 'courier', label: $gettext('Courier')}, {key: 'company_id', label: $gettext('Company')}, {key: 'addressTo', label: $gettext('Destination')}, {key: 'pickedupAt', label: $gettext('Pickedup At')}, {key: 'delayedBy', label: $gettext('Delayed By')}] :
          ['id', {key: 'courier', label: $gettext('Courier')}, {key: 'company_id', label: $gettext('Company')}, {key: 'addressTo', label: $gettext('Destination')}, {key: 'deliveredAt', label: $gettext('Delivered At')}, {key: 'delayedBy', label: $gettext('Delayed By')}, {key: 'qr', label: $gettext('QR')}]"
        :current-page="0" :per-page="1000" show-empty :empty-text="$gettext('There are no rows to show')">
        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong v-translate>Loading...</strong>
        </div>
        <template v-slot:cell(id)="row">
          <a :href="'/edit/shippings/' + row.value" target="_blank">{{ row.value | uuid }}</a> <a href="#"
            @click.prevent="copyToClipboard(row.value)" class="text-secondary"
            :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
        </template>
        <template v-slot:cell(courier)="row">
          <div v-if="row.item.courier">
            <user-card :user='row.item.courier' :profile-picture="false" :with-titles="false"
              :vehicle-types-prop="vehicleTypes" />
          </div>
        </template>
        <template v-slot:cell(company_id)="row">
          <div v-if="row.item.company_id">
            <b-badge variant="dark" v-translate>Company</b-badge><br>
            <a :href="'/edit/companies/' + row.item.company_id" target="_blank">#{{ row.item.company_id }}</a>
            {{ row.item.company.name }}
          </div>
          <div v-else>
            <b-badge variant="secondary" v-translate>Particular</b-badge><br>
            <a :href="'/edit/users/' + row.item.user_id" target="_blank">#{{ row.item.user_id }}</a>
            {{ row.item.user.name }}
          </div>
        </template>
        <template v-slot:cell(addressTo)="row">
          {{ row.item.address_to.formatted_address }}
          <div v-if="showingShippings === 'pickedup'" v-translate="{data: row.item.status}">
            Current Status: %{data}
          </div>
        </template>
        <template v-slot:cell(deliveredAt)="row">
          {{ moment.utc(row.item.status_history[0].created_at).tz($tz).format('L LT') }}
        </template>
        <template v-slot:cell(pickedupAt)="row">
          {{ moment.utc(row.item.status_history.find(x => x.status === 'INTRANSIT').created_at).tz($tz).format('L LT') }}
        </template>
        <template v-slot:cell(delayedBy)="row">
          <div v-if="showingShippings === 'pickedup'">
            {{ elapsedTime(row.item.status_history.find(x => x.status === 'INTRANSIT').created_at) }}
            <b-button size="sm" variant="primary" @click.prevent="forcePlatformCheck(row.item.id)" v-translate>
              Check ML Status
            </b-button>
          </div>
          <div v-else>
            {{ elapsedTime(row.item.status_history[0].created_at) }}
            <b-button size="sm" variant="primary" @click.prevent="forcePlatformCheck(row.item.id)" v-translate>
              Force Check
            </b-button>
          </div>
        </template>
        <template v-slot:cell(qr)="row">
          <div class="text-center"
            v-if="(row.item.external_label && row.item.external_label.code) || (row.item.external_label && row.item.external_label.id)">
            <b-button size="sm" variant="link" @click.prevent="qrData = row.item.external_label" v-b-modal.modalShowQr
              style="padding: .25rem">
              <font-awesome-icon icon="qrcode" size="3x" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: 'FlexesControl',
  data() {
    return {
      tabIndex: 0,
      flexesTypeId: [],
      notFlexesTypeId: [],
      platformDelivereds: [],
      groupedPlatformDeliveredsByCourier: [],
      groupedPlatformDeliveredsByCompany: [],
      totalsPlatformDelivereds: {},
      failedFlexGroupedByCourier: false,
      failedFlexGroupedByCompany: false,
      platformDeliveredsTotal: 0,
      platformDeliveredsOkTotal: 0,
      platformCheck: {},
      hoursToCheck: 12,
      toCheck: [],
      checkCount: 0,
      checkFixed: 0,
      bulkChecking: false,
      qrData: {},
      platformPickedups: [],
      groupedPlatformPickedupsByCourier: [],
      groupedPlatformPickedupsByCompany: [],
      pickedupFlexGroupedByCourier: false,
      pickedupFlexGroupedByCompany: false,
      shippings: [],
      showingShippings: 'delivered',
      selectedSubject: {},
      theSubject: null,
      filterWarehouse: null,
      intervalSummary: null,
      intervalCountdown: null,
      countdown: 120
    }
  },
  watch: {
    filterWarehouse(val) {
      if (val) {
        this.$cookies.set('warehouse', val)
      } else {
        this.$cookies.remove('warehouse')
      }
      this.setTimeout()
    },
    failedFlexGroupedByCourier(val) {
      if (val) {
        this.failedFlexGroupedByCompany = false
      }
    },
    failedFlexGroupedByCompany(val) {
      if (val) {
        this.failedFlexGroupedByCourier = false
      }
    },
    pickedupFlexGroupedByCourier(val) {
      if (val) {
        this.pickedupFlexGroupedByCompany = false
      }
    },
    pickedupFlexGroupedByCompany(val) {
      if (val) {
        this.pickedupFlexGroupedByCourier = false
      }
    }
  },
  created() {
    this.fetchWarehouses()
    this.fetchShippingTypes()
      .then(() => {
        this.flexesTypeId = [this.shippingTypes.find(x => x.name === 'mercado_flex').id]
        this.notFlexesTypeId = this.shippingTypes.filter(x => x.name !== 'mercado_flex').map(x => { return x.id })
        this.fetchVehicleTypes()
          .then(() => {
            this.filterWarehouse = this.$cookies.get('warehouse') || null
            this.setTimeout()
          })
      })
  },
  beforeDestroy() {
    clearTimeout(this.intervalSummary)
    clearInterval(this.intervalCountdown)
  },
  methods: {
    findStatusDate(statusHistory) {
      if (statusHistory[0].status === 'DELIVERED') {
        return statusHistory[0].created_at
      } else {
        statusHistory.reverse()
        let index = statusHistory.findIndex(x => x.status === 'INTRANSIT')
        if (index + 1 > statusHistory.length - 1) {
          return statusHistory[index].created_at
        } else {
          return statusHistory[index + 1].created_at
        }
      }
    },
    setTimeout() {
      clearTimeout(this.intervalSummary)

      this.intervalSummary = setTimeout(function () {
        this.setTimeout()
      }.bind(this), 120000)
      this.getPlatformDelivered()
      this.getPlatformPickedups()
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
    },
    async getPlatformDelivered() {
      let startDate = this.moment().tz(this.$tz).subtract(7, 'days').hours(this.$appConfig.flexCutOutHour).minutes(0).seconds(1).utc().format('YYYY-MM-DD HH:mm:ss')
      let endDate = this.moment().tz(this.$tz).subtract(2, 'minutes').utc().format('YYYY-MM-DD HH:mm:ss')
      let platformPendingScan = []

      // Ongoing without first visit date
      let params = {
        filter_groups: [
          {
            filters: [
              ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'mercado_flex').id],
              ['external_code', 'eq', null, 'true'],
              ['platform_id', 'eq', null, 'true'],
              ['status', 'in', ['READY', 'WAITING', 'INCIDENCE', 'ATPICKUPPOINT', 'INTRANSIT']],
              ['status_history.status', 'eq', 'INTRANSIT'],
              ['platform_first_visit_date', 'eq', null],
              ['updated_at', 'bt', [startDate, endDate]],
              ['courier_id', 'eq', null, 'true']
            ]
          }
        ],
        includes: ['company', 'status_history']
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }
      platformPendingScan.push(this.$http.get(this.$appConfig.api.baseUrl + 'shippings', { params: params }))

      // Delivered without first visit or delivered dates
      params = {
        filter_groups: [
          {
            filters: [
              ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'mercado_flex').id],
              ['external_code', 'eq', null, 'true'],
              ['platform_id', 'eq', null, 'true'],
              ['status', 'eq', 'DELIVERED'],
              ['updated_at', 'bt', [startDate, endDate]],
              ['courier_id', 'eq', null, 'true']
            ]
          },
          {
            or: true,
            filters: [
              // ['platform_first_visit_date', 'eq', null],
              ['platform_delivered_date', 'eq', null]
            ]
          }
        ],
        includes: ['company', 'status_history']
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }
      platformPendingScan.push(this.$http.get(this.$appConfig.api.baseUrl + 'shippings', { params: params }))

      return await Promise.all(platformPendingScan)
        .then(async responses => {
          let pendingScan = []
          for (const response of responses) {
            pendingScan = pendingScan.concat([...new Set(response.body.data)])
          }
          pendingScan = pendingScan.map(x => {
            if (x.status_history[0].status === 'DELIVERED' || x.status_history.filter(y => y.status === 'INTRANSIT').length > 1) {
              x.delayedSinceDate = this.findStatusDate(x.status_history)
              return x
            }
          }).filter(Boolean)
          pendingScan.sort((a, b) => b.delayedSinceDate.replace(/\D/g, '') - a.delayedSinceDate.replace(/\D/g, ''))
          let byCourier = {}
          let byCompany = {}

          for (let item of pendingScan) {
            if (!byCourier[item.courier.name]) {
              byCourier[item.courier.name] = item.courier
              byCourier[item.courier.name].failed = 1
              byCourier[item.courier.name].shippings = [item]
              byCourier[item.courier.name].roles = [
                {
                  name: 'courier'
                }
              ]
            } else {
              if (!byCourier[item.courier.name].failed) {
                byCourier[item.courier.name].failed = 1
              } else {
                byCourier[item.courier.name].failed = byCourier[item.courier.name].failed + 1
                byCourier[item.courier.name].shippings.push(item)
              }
            }

            if (!byCompany[item.company.name]) {
              byCompany[item.company.name] = item.company
              byCompany[item.company.name].failed = 1
              byCompany[item.company.name].shippings = [item]
            } else {
              if (!byCompany[item.company.name].failed) {
                byCompany[item.company.name].failed = 1
              } else {
                byCompany[item.company.name].failed = byCompany[item.company.name].failed + 1
                byCompany[item.company.name].shippings.push(item)
              }
            }
          }

          this.groupedPlatformDeliveredsByCourier = []
          this.groupedPlatformDeliveredsByCompany = []
          this.platformDelivereds = []
          this.$nextTick(() => {
            this.groupedPlatformDeliveredsByCourier = Object.values(byCourier)
            this.groupedPlatformDeliveredsByCompany = Object.values(byCompany)
            this.platformDelivereds = pendingScan
            this.platformDeliveredsTotal = pendingScan.length
          })

          this.getPlatformDeliveredOk()
        })
    },
    async getPlatformDeliveredOk() {
      let startDate = this.moment().tz(this.$tz).subtract(7, 'days').hours(this.$appConfig.flexCutOutHour).minutes(0).seconds(1).utc().format('YYYY-MM-DD HH:mm:ss')
      let endDate = this.moment().tz(this.$tz).subtract(2, 'minutes').utc().format('YYYY-MM-DD HH:mm:ss')
      let platformPendingScan = []

      // Ongoing without first visit date
      let params = {
        filter_groups: [
          {
            filters: [
              ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'mercado_flex').id],
              ['external_code', 'eq', null, 'true'],
              ['platform_id', 'eq', null, 'true'],
              ['status', 'in', ['READY', 'WAITING', 'INCIDENCE', 'ATPICKUPPOINT', 'INTRANSIT']],
              ['status_history.status', 'eq', 'INTRANSIT'],
              ['platform_first_visit_date', 'eq', null, 'true'],
              ['updated_at', 'bt', [startDate, endDate]],
              ['courier_id', 'eq', null, 'true']
            ]
          }
        ]
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }
      platformPendingScan.push(this.$http.get(this.$appConfig.api.baseUrl + 'shippings', { params: params }))

      // Delivered without first visit or delivered dates
      params = {
        filter_groups: [
          {
            filters: [
              ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'mercado_flex').id],
              ['external_code', 'eq', null, 'true'],
              ['platform_id', 'eq', null, 'true'],
              ['status', 'eq', 'DELIVERED'],
              ['platform_delivered_date', 'eq', null, 'true'],
              ['updated_at', 'bt', [startDate, endDate]],
              ['courier_id', 'eq', null, 'true']
            ]
          }
        ]
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }
      platformPendingScan.push(this.$http.get(this.$appConfig.api.baseUrl + 'shippings', { params: params }))

      return await Promise.all(platformPendingScan)
        .then(async responses => {
          this.platformDeliveredsOkTotal = 0
          for (const response of responses) {
            this.platformDeliveredsOkTotal += response.body.pagination.total
          }
        })
    },
    forcePlatformCheck(id) {
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + id + '/platform-information')
        .then(response => {
          this.platformCheck = {
            status: response.body.status,
            statusHistory: response.body.status_history,
            shippingId: id
          }
          this.$refs.modalPlatformCheck.show()
        }, error => {
          this.platformCheck = {}
          console.log(error)
        })
    },
    updateShippingPlatformInfo(id) {
      let params = {
        platform_first_visit_date: this.moment(this.platformCheck.statusHistory.date_first_visit).utc().format('YYYY-MM-DD HH:mm:ss'),
        platform_delivered_date: this.platformCheck.statusHistory.date_delivered ? this.moment(this.platformCheck.statusHistory.date_delivered).utc().format('YYYY-MM-DD HH:mm:ss') : null
      }
      this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + id, params)
        .then(response => {
          this.platformCheck = {}
          this.getPlatformDelivered()
          this.$refs.modalPlatformCheck.hide()
        })
    },
    async bulkForcePlatformCheck() {
      this.checkCount = 0
      this.checkFixed = 0
      this.toCheck = this.hoursToCheck ? [...this.platformDelivereds].filter(x => this.moment(x.delayedSinceDate).utc() >= this.moment.utc().subtract(this.hoursToCheck, 'hours')) : [...this.platformDelivereds]

      if (this.toCheck.length > 0) {
        this.bulkChecking = true

        // this.toCheck.reverse()
        const chunkSize = 10
        for (let i = 0; i < this.toCheck.length; i += chunkSize) {
          const chunk = this.toCheck.slice(i, i + chunkSize)
          await this.doBulkForcePlatformCheck(chunk)
        }

        this.bulkChecking = false
        this.setTimeout()
      }
    },
    async doBulkForcePlatformCheck(chunk) {
      let checkPromise = []
      for (const item of chunk) {
        checkPromise.push(this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + item.id + '/platform-information'))
      }
      return await Promise.all(checkPromise)
        .then(responses => {
          for (const response of responses) {
            this.checkCount++
            let params = {}
            if (response.body.status === 'delivered') {
              params = {
                platform_first_visit_date: this.moment(response.body.status_history.date_first_visit).utc().format('YYYY-MM-DD HH:mm:ss'),
                platform_delivered_date: this.moment(response.body.status_history.date_delivered).utc().format('YYYY-MM-DD HH:mm:ss')
              }
            } else if (response.body.status === 'shipped' && !chunk.find(x => x.external_code === response.body.id + '').platform_first_visit_date && response.body.status_history.date_first_visit) {
              params = {
                platform_first_visit_date: this.moment(response.body.status_history.date_first_visit).utc().format('YYYY-MM-DD HH:mm:ss')
              }
            } else if (response.body.status === 'cancelled') {
              params = {
                platform_first_visit_date: '0000-00-00 00:00:00',
                platform_delivered_date: '0000-00-00 00:00:00'
              }
            }
            if (params.platform_first_visit_date || params.platform_delivered_date) {
              this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + chunk.find(x => x.external_code === response.body.id + '').id, params)
                .then(response => {
                  this.checkFixed++
                })
            }
          }
        }, e => {
          console.log(e)
          let params = {
            platform_first_visit_date: '0000-00-00 00:00:00',
            platform_delivered_date: '0000-00-00 00:00:00'
          }
          this.$http.patch(e.url.replace('/platform-information', ''), params)
            .then(response => {
              this.checkFixed++
            })
        })
    },
    getPlatformPickedups() {
      let startDate = this.moment().tz(this.$tz).subtract(7, 'days').hours(this.$appConfig.flexCutOutHour).minutes(0).seconds(1).utc().format('YYYY-MM-DD HH:mm:ss')
      let endDate = this.moment().tz(this.$tz).subtract(2, 'minutes').utc().format('YYYY-MM-DD HH:mm:ss')

      let params = {
        filter_groups: [
          {
            filters: [
              ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'mercado_flex').id],
              ['external_code', 'eq', null, 'true'],
              ['platform_id', 'eq', null, 'true'],
              ['status', 'in', ['INTRANSIT', 'INCIDENCE']],
              ['external_label', 'eq', null],
              ['updated_at', 'bt', [startDate, endDate]],
              ['courier_id', 'eq', null, 'true']
            ]
          }
        ],
        sort: [
          {
            key: 'updated_at',
            direction: 'desc'
          }
        ],
        includes: ['company', 'courier.courier_available.tracking', 'status_history']
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['from_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings', { params: params })
        .then(response => {
          let byCourier = {}
          let byCompany = {}

          for (let item of response.body.data) {
            if (!byCourier[item.courier.name]) {
              byCourier[item.courier.name] = item.courier
              byCourier[item.courier.name].failed = 1
              byCourier[item.courier.name].shippings = [item]
              byCourier[item.courier.name].roles = [
                {
                  name: 'courier'
                }
              ]
            } else {
              if (!byCourier[item.courier.name].failed) {
                byCourier[item.courier.name].failed = 1
              } else {
                byCourier[item.courier.name].failed = byCourier[item.courier.name].failed + 1
                byCourier[item.courier.name].shippings.push(item)
              }
            }

            if (!byCompany[item.company.name]) {
              byCompany[item.company.name] = item.company
              byCompany[item.company.name].failed = 1
              byCompany[item.company.name].shippings = [item]
            } else {
              if (!byCompany[item.company.name].failed) {
                byCompany[item.company.name].failed = 1
              } else {
                byCompany[item.company.name].failed = byCompany[item.company.name].failed + 1
                byCompany[item.company.name].shippings.push(item)
              }
            }
          }

          this.groupedPlatformPickedupsByCourier = []
          this.groupedPlatformPickedupsByCompany = []
          this.platformPickedups = []
          this.$nextTick(() => {
            this.groupedPlatformPickedupsByCourier = Object.values(byCourier)
            this.groupedPlatformPickedupsByCompany = Object.values(byCompany)
            this.platformPickedups = response.body.data
          })

          this.countdown = 120
          this.setIntervalCountdown()
        })
    }
  }
}
</script>
